import { useAuthContext } from "providers/Auth";

export const useUnitsPropertiesDictionary = () => {
  const { type } = useAuthContext();

  return {
    unit: type.isSitesAndCommunities ? "site" : "unit",
    Unit: type.isSitesAndCommunities ? "Site" : "Unit",
    units: type.isSitesAndCommunities ? "sites" : "units",
    Units: type.isSitesAndCommunities ? "Sites" : "Units",
    property: type.isSitesAndCommunities ? "community" : "property",
    Property: type.isSitesAndCommunities ? "Community" : "Property",
    properties: type.isSitesAndCommunities ? "communities" : "properties",
    Properties: type.isSitesAndCommunities ? "Communities" : "Properties",
    propertyGroup: type.isSitesAndCommunities
      ? "community group"
      : "property group",
    PropertyGroup: type.isSitesAndCommunities
      ? "Community group"
      : "Property group"
  };
};
